
import Vue, { PropType } from 'vue'

type DataType = {
  width: number;
}

export default Vue.extend({
  name: 'BaseTableCellContent',

  props: {
    content: String as PropType<string>,
  },

  data(): DataType {
    return {
      width: 0,
    }
  },

  computed: {
    showTooltip(): boolean {
      return this.width >= 145
    }
  },

  mounted(): void {
    this.width = this.$el.getElementsByClassName('content')[0].clientWidth
  }
})
